module.exports = __webpack_public_path__ + "static/media/ic-editar-gray.bf2cc81b.svg";